import { lazy, Suspense } from 'react';
import ReactDOM from 'react-dom';

import { Route, Switch, BrowserRouter as Router } from 'react-router-dom';

import SpinnerView from '@@/components/SpinnerView';
import type { IWindow } from '@@/interfaces/window.interface';
import { logException } from '@@/utils';
import { initIfEnabled as initSentryIfEnabled } from '@@/utils/sentry';

import analytics from './analytics';
import './index.css';

declare global {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  interface Window extends IWindow {}
}

const App = lazy(() => import('@@/components/App'));

/**
 * Configure third-party
 */

initSentryIfEnabled();

// Load Segment
if (process.env.REACT_APP_SEGMENT_WRITE_KEY && !window.Cypress) {
  analytics.load(process.env.REACT_APP_SEGMENT_WRITE_KEY);
}

// Load Zendesk
setTimeout(() => {
  const s = document.createElement('script');
  s.id = 'ze-snippet';
  s.src = `https://static.zdassets.com/ekr/snippet.js?key=${process.env.REACT_APP_ZENDESK_KEY}`;
  s.onerror = logException;
  document.head.appendChild(s);
}, 2500);

/**
 * Mount the app
 */
ReactDOM.render(
  <Router>
    <Suspense fallback={<SpinnerView data-testid="App_spinner" />}>
      <Switch>
        <Route component={App} />
      </Switch>
    </Suspense>
  </Router>,
  document.getElementById('root')
);
